var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: { color: "transparent", "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tabs-slider", { attrs: { color: "primary" } }),
          _vm._v(" "),
          _vm._l(_vm.tabs, function(tabItem) {
            return _c("v-tab", { key: tabItem }, [
              _vm._v("\n        " + _vm._s(tabItem) + "\n      ")
            ])
          }),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              attrs: { touchless: "" },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            _vm._l(3, function(item, index) {
              return _c(
                "v-tab-item",
                { key: "item" + index },
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "grid-list-lg": "" } },
                    [
                      _vm.tab === 0
                        ? _c(
                            "v-layout",
                            {
                              attrs: {
                                "justify-space-around": "",
                                row: "",
                                wrap: ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(_vm.$t("name")) +
                                                ": " +
                                                _vm._s(
                                                  _vm.userData &&
                                                    _vm.userData.name
                                                )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(_vm.$t("email")) +
                                                ": " +
                                                _vm._s(
                                                  _vm.userData &&
                                                    _vm.userData.email
                                                )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.isOrganization || _vm.isWarehouse
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        _vm.isOrganization
                                                          ? "organization"
                                                          : "warehouse"
                                                      )
                                                    ) +
                                                    ": " +
                                                    _vm._s(
                                                      (_vm.isWarehouse &&
                                                        _vm.warehouseName) ||
                                                        (_vm.isOrganization &&
                                                          _vm.organizationName)
                                                    ) +
                                                    "\n                  "
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.isOrganization
                                            ? _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("invitationCode")
                                                  ) + ": "
                                                ),
                                                _c(
                                                  "span",
                                                  { attrs: { id: "invCode" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$store.getters
                                                          .tenant.invitationCode
                                                      )
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.isModeLabel
                                            ? _c(
                                                "div",
                                                [
                                                  _vm._v(
                                                    "\n                    apiKey: " +
                                                      _vm._s(
                                                        _vm.userData &&
                                                          _vm.userData.apiKey
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.copyToClipboard(
                                                            _vm.userData.apiKey
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("content_copy")]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            [
                                              _vm.isOrganization
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        id: "genCode"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.generateInvitationCode.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "generateInvitationCode"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.isOrganization &&
                                              !_vm.isWarehouse &&
                                              _vm.isOfferAndTaskAvailable
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        id: "joinOrg"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.editApplyFunc.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "joinAnOrganization"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: { color: "secondary" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.resetPassword.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("resetPassword")
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-space-between": ""
                                              }
                                            },
                                            [
                                              _c("v-flex", [
                                                _c(
                                                  "a",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        _vm.suggestionDialog = true
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("suggestion?")
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]),
                                              _c("v-spacer"),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "text-xs-right"
                                                },
                                                [
                                                  _vm._v(
                                                    "©2018 Version: " +
                                                      _vm._s(
                                                        _vm.$store.getters
                                                          .version
                                                      )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.isOrganization &&
                              !_vm.isWarehouse &&
                              _vm.isOfferAndTaskAvailable
                                ? _c(
                                    "v-flex",
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            "justify-start": "",
                                            "align-baseline": ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass:
                                                "success--text caption"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "realtime-border px-1"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("realTIME"))
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-data-table", {
                                        staticClass: "elevation-1",
                                        attrs: {
                                          headers: _vm.headers,
                                          items: _vm.tenants,
                                          "hide-actions": "",
                                          label: "Organizations"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "items",
                                              fn: function(props) {
                                                return [
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.item.tenantName
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(props.item.status)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-center"
                                                    },
                                                    [
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            row: "",
                                                            lg3: ""
                                                          }
                                                        },
                                                        [
                                                          props.item.requestID
                                                            ? _c(
                                                                "v-flex",
                                                                [
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "primary",
                                                                        flat: ""
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          return _vm.cancelRequest(
                                                                            props
                                                                              .item
                                                                              .requestID
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "cancel"
                                                                          )
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _c(
                                                                "v-flex",
                                                                [
                                                                  _c(
                                                                    "LoaderButton",
                                                                    {
                                                                      attrs: {
                                                                        flat:
                                                                          "",
                                                                        buttonText: _vm.$t(
                                                                          "unsubscribe"
                                                                        ),
                                                                        promiseAwait:
                                                                          _vm.unsubscribeOrg,
                                                                        promiseItem:
                                                                          props.item
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.tab === 1 &&
                  index === 1 &&
                  !_vm.isOrganization &&
                  !_vm.isWarehouse &&
                  _vm.isOfferAndTaskAvailable
                    ? _c(
                        "v-layout",
                        { attrs: { column: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "primary",
                                        id: "addSelfAddress"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.addAddressFunc.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("addAnAddress")))]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs8: "", md3: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "append-icon": "filter_list",
                                      label: _vm.$t("search"),
                                      "single-line": "",
                                      "hide-details": ""
                                    },
                                    model: {
                                      value: _vm.filter,
                                      callback: function($$v) {
                                        _vm.filter = $$v
                                      },
                                      expression: "filter"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-data-table", {
                            staticClass: "elevation-2 myDense",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.sites,
                              "item-key": "siteName",
                              search: _vm.filter,
                              pagination: _vm.pagination
                            },
                            on: {
                              "update:pagination": function($event) {
                                _vm.pagination = $event
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "items",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [_vm._v(_vm._s(props.item.siteName))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [_vm._v(_vm._s(props.item.address1))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [_vm._v(_vm._s(props.item.address2))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [_vm._v(_vm._s(props.item.state))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [_vm._v(_vm._s(props.item.city))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [_vm._v(_vm._s(props.item.zip))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-center" },
                                        [
                                          _c(
                                            "v-layout",
                                            [
                                              _c(
                                                "v-flex",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        dark: "",
                                                        color: "primary",
                                                        flat: ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.editAddressFunc(
                                                            props.item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("edit"))
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        dark: "",
                                                        color: "primary",
                                                        flat: ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.deleteSite(
                                                            props.item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("delete"))
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tab === 2 &&
                  !_vm.isOrganization &&
                  !_vm.isWarehouse &&
                  _vm.isOfferAndTaskAvailable
                    ? _c("v-layout", [_c("PaymentMethods")], 1)
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("FormSubmitPopup", {
        attrs: {
          title: _vm.$t("joinAnOrganization"),
          rightButtonText: _vm.$t("apply"),
          rightMethod: _vm.joinSubmitted,
          small: ""
        },
        on: {
          popupClose: function($event) {
            _vm.editApply = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-layout",
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: _vm.$t("invitationCode"),
                        "single-line": ""
                      },
                      model: {
                        value: _vm.requestCode,
                        callback: function($$v) {
                          _vm.requestCode = $$v
                        },
                        expression: "requestCode"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c("v-text-field", {
                      attrs: { label: _vm.$t("note"), "single-line": "" },
                      model: {
                        value: _vm.note,
                        callback: function($$v) {
                          _vm.note = $$v
                        },
                        expression: "note"
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.editApply,
          callback: function($$v) {
            _vm.editApply = $$v
          },
          expression: "editApply"
        }
      }),
      _vm._v(" "),
      _vm.addAddress
        ? _c("EditAddress", {
            attrs: {
              actionFunc: _vm.addressSubmitted,
              siteNames: _vm.siteNames
            },
            model: {
              value: _vm.addAddress,
              callback: function($$v) {
                _vm.addAddress = $$v
              },
              expression: "addAddress"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editAddress
        ? _c("EditAddress", {
            attrs: {
              address: _vm.addressInEdit,
              editMode: "",
              siteNames: _vm.siteNames,
              actionFunc: _vm.editAddressSubmitted,
              checkDistribution: function() {
                return _vm.$store.dispatch(
                  "checkUserDistribution",
                  _vm.addressInEdit
                )
              }
            },
            model: {
              value: _vm.editAddress,
              callback: function($$v) {
                _vm.editAddress = $$v
              },
              expression: "editAddress"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.suggestionDialog
        ? _c("SuggestionsPopup", {
            attrs: {
              actionMethod: _vm.SubmitSuggestion,
              email: _vm.suggestion.email,
              name: _vm.suggestion.name
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "inputText",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        [
                          _c("v-flex", [
                            _vm._v(_vm._s(_vm.$t("profileTips1")))
                          ]),
                          _vm._v(" "),
                          _c("v-flex", [
                            _vm._v(_vm._s(_vm.$t("profileTips2")))
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            _vm._s(_vm.$t("profileContact")) + "\n        "
                          ),
                          _c("br"),
                          _vm._v("QQ: 3372450933\n        "),
                          _c("br"),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(_vm._s(_vm.$t("or")) + "\n        "),
                          _c("br"),
                          _vm._v(" "),
                          _c("br")
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              884106263
            ),
            model: {
              value: _vm.suggestionDialog,
              callback: function($$v) {
                _vm.suggestionDialog = $$v
              },
              expression: "suggestionDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf1681ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf1681ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = null
// module chunks = 